import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Typography, TypographyProps } from '@scale/scaleui';

export type SearchResultsListHeaderProps = TypographyProps & {
  className?: string;
  children: ReactNode;
};

export function SearchResultsListHeader({
  className,
  children,
  ...other
}: SearchResultsListHeaderProps) {
  return (
    <Typography.Overline3
      className={twMerge(
        'sticky top-0 flex items-center gap-2 h-8 px-3 uppercase bg-neutral-50',
        className,
      )}
      {...other}
    >
      {children}
    </Typography.Overline3>
  );
}
